import { render } from "./USDownload.vue?vue&type=template&id=65dfb2e8"
import script from "./USDownload.vue?vue&type=script&lang=js"
export * from "./USDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__